module.exports = __webpack_public_path__ + "img/logo-main.8824cb91.png";